'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@achra/ui/tooltip';
import { ArrowRight } from 'lucide-react';
import { useServicePurchaseStep } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { ServicePurchaseStep } from '@/modules/service-purchase/types';
function continueDisabledHint(step: ServicePurchaseStep): string | null {
  if (step === ServicePurchaseStep.Summary) {
    return 'Fill out the form and request a quote to continue.';
  }
  return null;
}
function NavigationButtons() {
  const $ = _c(19);
  const {
    activeStep,
    goBack,
    goToStep
  } = useServicePurchaseStep();
  const isConfirmation = activeStep === ServicePurchaseStep.Confirmation;
  const isContinueEnabled = activeStep === ServicePurchaseStep.SelectOperator || activeStep === ServicePurchaseStep.ConfigureServices;
  let t0;
  if ($[0] !== activeStep || $[1] !== isContinueEnabled) {
    t0 = !isContinueEnabled ? continueDisabledHint(activeStep) : null;
    $[0] = activeStep;
    $[1] = isContinueEnabled;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const continueDisabledReason = t0;
  let t1;
  if ($[3] !== activeStep || $[4] !== goToStep) {
    t1 = function handleContinue() {
      if (activeStep === ServicePurchaseStep.SelectOperator) {
        goToStep(ServicePurchaseStep.ConfigureServices);
        return;
      }
      goToStep(ServicePurchaseStep.Summary);
    };
    $[3] = activeStep;
    $[4] = goToStep;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleContinue = t1;
  const t2 = !isContinueEnabled;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRight className="size-4 transition-transform duration-200 ease-in-out group-hover/link:translate-x-1.5" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleContinue || $[8] !== t2) {
    t4 = <Button variant="default" disabled={t2} onClick={handleContinue} className="group/link pr-7! pl-8!">Continue{t3}</Button>;
    $[7] = handleContinue;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const continueButton = t4;
  let t5;
  if ($[10] !== goBack) {
    t5 = <Button variant="secondary" onClick={goBack} className="w-fit">Back</Button>;
    $[10] = goBack;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== continueButton || $[13] !== continueDisabledReason || $[14] !== isConfirmation) {
    t6 = !isConfirmation && (continueDisabledReason ? <Tooltip><TooltipTrigger asChild={true}><span className="inline-flex cursor-not-allowed" tabIndex={0}>{continueButton}</span></TooltipTrigger><TooltipContent side="bottom" align="end">{continueDisabledReason}</TooltipContent></Tooltip> : continueButton);
    $[12] = continueButton;
    $[13] = continueDisabledReason;
    $[14] = isConfirmation;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="flex items-center justify-between gap-2 sm:justify-normal">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
export { NavigationButtons };